import api from './api';

// Available icon options for services
const iconOptions = [
  'FaBuilding', 'FaCog', 'FaRoad', 'FaTasks', 'FaCouch', 'FaHardHat',
  'FaDraftingCompass', 'FaRulerCombined', 'FaCity', 'FaWarehouse',
  'FaBridge', 'FaHome', 'FaIndustry', 'FaLandmark', 'FaMapMarkedAlt'
];

// Normalize API response (snake_case) → frontend shape (camelCase)
const normalizeService = (item) => ({
  id: item.id,
  title: item.title,
  icon: item.icon || 'FaBuilding',
  shortDescription: item.short_description || '',
  detailedDescription: item.detailed_description || '',
  isActive: item.status === true || item.status === 1,
  createdAt: item.created_at,
  updatedAt: item.updated_at,
});

// Map frontend camelCase → API snake_case payload
const toApiPayload = (data) => ({
  title: data.title,
  short_description: data.shortDescription,
  detailed_description: data.detailedDescription,
  icon: data.icon,
  status: data.isActive,
});

export const serviceService = {
  getAll: async (params = {}) => {
    const apiParams = {
      page: params.page || 1,
      per_page: params.limit || 10,
      ...(params.search ? { search: params.search } : {}),
      ...(params.status !== undefined ? { status: params.status } : {}),
    };
    const response = await api.get('/services', { params: apiParams });
    // Shape: { success, data: { current_page, data: [...], total, last_page, ... } }
    const pagination = response.data?.data;
    const rawList = pagination?.data ?? [];
    return {
      data: {
        services: rawList.map(normalizeService),
        total: pagination?.total ?? rawList.length,
        page: pagination?.current_page ?? 1,
        totalPages: pagination?.last_page ?? 1,
      },
    };
  },

  getById: async (id) => {
    const response = await api.get(`/services/${id}`);
    const item = response.data?.data ?? response.data;
    return { data: normalizeService(item) };
  },

  create: async (data) => {
    const response = await api.post('/services', toApiPayload(data));
    const item = response.data?.data ?? response.data;
    return { data: normalizeService(item) };
  },

  update: async (id, data) => {
    const response = await api.put(`/services/${id}`, toApiPayload(data));
    const item = response.data?.data ?? response.data;
    return { data: normalizeService(item) };
  },

  delete: async (id) => {
    return api.delete(`/services/${id}`);
  },

  toggleStatus: async (id) => {
    const response = await api.patch(`/services/${id}/toggle-status`);
    const item = response.data?.data ?? response.data;
    return { data: normalizeService(item) };
  },

  getIconOptions: async () => {
    return Promise.resolve({ data: iconOptions });
  },
};
